import { faFacebookF, faYoutube, faTiktok, faInstagram } from "@fortawesome/free-brands-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "react-router-dom";

const currentYear = new Date().getFullYear();

function Footer({ style }) {
    return (
        <footer className={`footer ${style ? 'dark-mode' : ""}`}>
            
            <Container>
                <Row className="justify-content-between">
                    <Col lg={4} md={6} className="mb-4">
                        <div className="footer-section">
                            <div className="footer-logo">
                                <img src="/images/logo-light.webp" alt="د.مينا زكريا"/>
                            </div>
                            <p className="footer-description">
                                منصة تعليمية متخصصة في ال chemistry   تحت إشراف  د.مينا زكريا  
                            </p>
                        </div>
                    </Col>
                    
                    <Col lg={8} md={6} className="mb-4">
                        <div className="footer-section">
                            <h5>تواصل معنا</h5>
                            <div className="social-links">
                                <Link to="https://youtube.com/@dr.minazakaria-chemistry?si=miVLbtREFr5I4Jnn" target="_blank" rel="noopener noreferrer" className="social-link" aria-label="YouTube">
                                    <FontAwesomeIcon icon={faYoutube} />
                                </Link>
                                <Link to="https://www.tiktok.com/@dr.minas.team?_r=1&_t=ZS-93cB7fMlMds" target="_blank" rel="noopener noreferrer" className="social-link" aria-label="TikTok">
                                    <FontAwesomeIcon icon={faTiktok} />
                                </Link>
                                <Link to="https://www.instagram.com/dr_mina_zakaria?igsh=MXU4bXowZjkzcnl4eA==" target="_blank" rel="noopener noreferrer" className="social-link" aria-label="Instagram">
                                    <FontAwesomeIcon icon={faInstagram} />
                                </Link>
                                <Link to="https://www.facebook.com/share/1DkKWtb5rW/?mibextid=wwXIfr" target="_blank" rel="noopener noreferrer" className="social-link" aria-label="Facebook">
                                    <FontAwesomeIcon icon={faFacebookF} />
                                </Link>
                            </div>
                        </div>
                    </Col>
                </Row>
                
                <div className="footer-bottom">
                    <div className="copyright">
                        <span>Developed by</span> 
                        <Link to="https://www.facebook.com/said.sayed.3386" target="_blank">Said</Link> , 
                        <Link to="https://www.facebook.com/ahmed.abdelhamidnassef" target="_blank">Nassef</Link> 
                        <span>All Copy Rights Reserved © {currentYear}</span>
                    </div>
                </div>
            </Container>
        </footer>
    );
}

export default Footer;